import type { AdvertisingPackageRequest } from '@/api/data-contracts';
import { FilterValues } from '@/shared/ui/GeneratikTable';

export const filterValuesToPackageRequest = (
  filterValues: FilterValues,
  userType?: string,
): Partial<AdvertisingPackageRequest> => {
  const request: Partial<AdvertisingPackageRequest> = {};

  const packageName = filterValues.packageName as string | undefined;
  if (packageName) {
    request.packageName = packageName;
  }

  const dateRange = filterValues.dateRange as { start?: string; end?: string } | undefined;
  if (dateRange?.start) {
    request.start = dateRange.start.includes('T')
      ? dateRange.start
      : `${dateRange.start}T00:00:00Z`;
  }
  if (dateRange?.end) {
    request.end = dateRange.end.includes('T') ? dateRange.end : `${dateRange.end}T20:59:59Z`;
  }

  const status = filterValues.status as string[] | undefined;
  if (status?.length) {
    // @ts-ignore
    request.status = status;
  }

  const location = filterValues.location as string[] | undefined;
  if (location?.length) {
    request.location = location;
  }

  const city = filterValues.city as string[] | undefined;
  if (city?.length) {
    request.city = city;
  }

  const supportType = filterValues.supportType as string[] | undefined;
  if (supportType?.length) {
    request.supportType = supportType;
  }

  const exposureType = filterValues.exposureType as string[] | undefined;
  if (exposureType?.length) {
    // @ts-ignore
    request.exposureType = exposureType;
  }

  const placementArea = filterValues.placementArea as string[] | undefined;
  if (placementArea?.length) {
    // @ts-ignore
    request.placementArea = placementArea;
  }

  const published = filterValues.published as string | undefined;
  if (userType === 'location') {
    request.published = true;
  } else if (published?.length) {
    request.published = published === 'true';
  }

  return request;
};
